import { grey, red } from "@mui/material/colors";

const styles = {
  table: {
    padding: 0,
  },
  principalContainer: {
    padding: "0",
  },
  skeletonMainContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "0px !important",
  },
  skeletonSecondaryContainer: {
    display: "flex",
    gap: "12px",
    padding: "0px !important",
  },
  mainContainer: {
    backgroundColor: "white",
    borderRadius: "1rem",
    width: "100%",
    padding: "20px",
    display: "flex",
    justifyContent: "center",
  },
  circularProgress: {
    color: red,
  },
  checkCircleIcon: {
    fontSize: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  boldHeader: {
    fontWeight: "bold",
  },
  noDataContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  noDataIcon: {
    fontSize: "32px",
    marginRight: "12px",
  },
  noDataTitle: {
    textAlign: "center",
    fontSize: "20px",
    fontWeight: "bold",
  },
  noDataSubtitle: {
    textAlign: "center",
    color: grey[500],
  },
};

export default styles;
